const url = process.env.NODE_ENV === 'production'
  ? 'https://brew.nox.rip/api'
  : 'http://localhost:8081/api'//'https://brewapi.ngrok.io/api'
const firestore = process.env.NODE_ENV === 'production'
  ? {
    projectId: 'brew2-bd6c4',
    apiKey: 'AIzaSyBbQK9SJCH2EDRYhSkGnN_Qsgve82JYckU'
    // Old db:
    // projectId: 'brew-e9597',
    // apiKey: 'AIzaSyDgTrX3AcAZjPYx7xGfb89fmbMRX1RS1MQ'
  }
  : {
    projectId: 'brew-dev',
    apiKey: 'AIzaSyC2yzId7IlRlxJB9l7o0Q8vwZok3GdZmjY'
  }

const redirectUri = process.env.NODE_ENV === 'production'
  ? 'https://brew-admin.nox.rip/'
  : 'http://localhost:8080/'
const config = {
  firestore,
  twitch: {
    clientId: '6bcosxuyu9il4h9898vt5p1uhag1sb',
    redirectUri, //'https://brewapi.ngrok.io/api/set-token'
  },
  api: {
    url
  }
}

export default config
